import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { CircleComponentModule } from 'shared/components/circle/circle.module';
import { OverlayComponentModule } from 'shared/components/overlay/overlay.module';

import { NotificationsCardModule } from '../notifications-card/notifications-card.module';
import { NotificationsMenuComponent } from './notifications-menu.component';

@NgModule({
	declarations: [NotificationsMenuComponent],
	exports: [NotificationsMenuComponent],
	providers: [],
	imports: [
		CommonModule,
		TranslateModule,
		FreudTypographyModule,
		NotificationsCardModule,
		OverlayComponentModule,
		CircleComponentModule,
	],
})
export class NotificationsMenuModule {}
